import React, { Component } from 'react';
import './App.css';
import Header from './header';
import NAVIGATION from './navigation';
import { AppContextProvider } from './context/applicationContext';
import PropTypes from 'prop-types';
import { SnackbarProvider } from 'notistack';
import { withSnackbar } from 'notistack';
import {BrowserRouter} from 'react-router-dom';

class App extends Component {
    constructor(props) {        
        super(props);
        this.setStateCustom = (param, value) => {
            for (var key in this.state) {
                if (this.state.hasOwnProperty(key)) {
                    if (key == param) {
                        this.setState({ [key]: value });
                    }
                }
            }

        }

        this.showSnack = (variant, msg) => {
            this.props.enqueueSnackbar(msg, { variant });
        }

        this.state = { 
            setStateCustom: this.setStateCustom, 
            userId: null, showSnack: this.showSnack, 
            redirect: false, 
            userSite: null, 
            token: null, 
            expireIn: null, 
            username: null, 
            password: null,
            approveListDisabled:false,
            consentListDisabled:false,
            days:0,
            daysAdded:0,
            redirectFrom: 'myHolidays'
        };


    }

    render() {
        
        return (
            <AppContextProvider value={this.state}>
                <SnackbarProvider maxSnack={3} anchorOrigin={{vertical: 'top',horizontal: 'left',}}>
                    <div>
                        {/* <Header /> */}
                        <BrowserRouter>
                        <NAVIGATION />
                        </BrowserRouter>
                    </div>
                </SnackbarProvider>
            </AppContextProvider>
        );
    }
}
// App.propTypes = {
//     enqueueSnackbar: PropTypes.func.isRequired,
//   };
export default App;
